import React from 'react'
import LoadingSpin from '../../components/LoadingSpin'
import { BrowserRouter as Router, Link, Redirect } from 'react-router-dom'
import Helmet from 'react-helmet'
import ErrorMessage from '../../components/ErrorMessage'
import { config } from '../../components/Constants'
import { Button, Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashAlt, faUserPlus } from '@fortawesome/free-solid-svg-icons'

class MessagesList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      error: null,
      isLoaded: false,
      remove: false,
      clients: {},
      redirect: null,
      types: {},
      messages: []
    }
    this.MessageStatuses = {};
    this.removeMessage = this.removeMessage.bind(this);
  }

  removeMessage(event, id) {
    if (event && event.preventDefault) {
      event.preventDefault();
      //id = event.target.getAttribute('id');
    }
    this.setState({
      remove: id
    });
    this.render();
    return false;
  }

  componentDidMount () {
    this.props.MessageStatuses.map((state, key) => {
      this.MessageStatuses[state.id] = state.name;
    });
    fetch(config.API_URL + '/api/messages', {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(
        (result) => {
          if (result.error) {
            this.setState({
              messages: [],
              isLoaded: true,
              error: result.error
            });
          } else if (result) {
            let types = {};
            let objects = {};
            result.types.map((type, key) => {
              types[type.id] = type.nazwa;
            });
            result.clients.map((type, key) => {
              objects[type.id] = type.nazwa;
            });
            this.setState({
              messages: result.messages,
              clients: objects,
              types: types,
              isLoaded: true
            });
          }
        },
        (error) => {
          this.setState({
            messages: [],
            isLoaded: true,
            error: error
          });
        }
      )
  }

  render () {
    const { error, isLoaded, messages, remove, clients, types, redirect } = this.state;
    const that = this
    if (redirect !== null) {
      window.location.reload();
    } else if (!isLoaded) {
      return (
        <LoadingSpin/>
      )
    } else if (error) {
      return (
        <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
          { 'title': 'Powrót', 'callback': function () {that.setState({ redirect: '/messages', error: null })} }
        ]} handleClose={() => {that.setState({ redirect: '/messages', error: null })}}/>
      )
    } else if (remove) {
      return (
        <ErrorMessage title="Usuwanie komunikatu" text="Czy na pewno chcesz usunąć ten komunikat?" buttons={[
          {
            'title': 'Tak', 'callback': function () {
              that.setState({
                isLoaded: false
              });
              fetch(config.API_URL + '/api/messages/delete', {
                credentials: 'include',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                'method': 'POST',
                'body': JSON.stringify({id: remove})
              })
                .then(res => res.json())
                .then(
                  (result) => {
                    if (result.error) {
                      that.setState({
                        isLoaded: true,
                        error: result.error
                      });
                    } else if (result) {
                      that.setState({
                        redirect: '/messages',
                        isLoaded: true
                      });
                    }
                  },
                  (error) => {
                    that.setState({
                      isLoaded: true,
                      error: error
                    });
                  }
                );
            }
          },
          {
            'title': 'Nie', 'callback': function () {
              that.setState({remove: null, error: null});
            }
          }
        ]} handleClose={() => {
          that.setState({remove: null, error: null});
        }}/>
      );
    } else {
      return (
        <React.Fragment>
          <Helmet>
            <title>Komunikaty</title>
          </Helmet>
          <header className="clients-header">
            <h1>Komunikaty</h1>
            <Row>
              <Col sm={12}>
                <Link to={'/messages/edit'}><Button><FontAwesomeIcon icon={faUserPlus}/> Dodaj nowy komunikat</Button></Link>
              </Col>
            </Row>
          </header>
          <div className="section-div">
            <table className="data">
              <thead id="tableHead">
              <tr>
                <th>ID</th>
                <th>Komunikat</th>
                <th>Obiekt</th>
                <th>Status</th>
                <th>Typ</th>
                <th>Timer</th>
                <th>Od</th>
                <th>Do</th>
                <th className="center" colSpan="2">Akcje</th>
              </tr>
              </thead>
              <tbody>
              {messages ? messages.map((message, mkey) => {
                return (
                  <tr key={mkey}>
                    <td>{message.id}</td>
                    <td>{message.tytul}</td>
                    <td>{message.klienci_id ? clients[message.klienci_id] : '-- Wszystkie --'}</td>
                    <td>{this.MessageStatuses[message.status]}</td>
                    <td>{types[message.klienci_komunikaty_typy_id]}</td>
                    <td>{message.timer_do ? message.timer_do : '---'}</td>
                    <td>{message.od}</td>
                    <td>{message.do}</td>
                    <td className="center actions">
                      <Link to={'/messages/edit/' + message.id}>
                        <FontAwesomeIcon icon={faEdit} title="Edytuj" />
                      </Link>
                    </td>
                    <td className="center actions">
                      <a href="#" onClick={(event) => { this.removeMessage(event, message.id); }}>
                        <FontAwesomeIcon icon={faTrashAlt} title="Usuń" />
                      </a>
                    </td>
                  </tr>
                )
              }) :
                <tr>
                  <td colSpan={13}>
                    Brak załadowanych komunikatów
                  </td>
                </tr>
              }
              </tbody>
            </table>
          </div>
        </React.Fragment>
      )
    }
  }
}

export default MessagesList
